import React from "react";
import './Info.module.css'

export const Info = () => {
    return (
        <div className='infoContainer'>
            <div className='contactInformation'>
                <div>
                    <p>e-mail. bozjoaquinboz@gmail.com</p>
                    <p>ig. <a href='https://www.instagram.com/bozjoaquinboz/' target="_blank" rel="noreferrer">@joaquin.boz</a></p>
                </div>
                <div>
                    <p>Buenos Aires, ARG</p>
                    <p><a href='https://www.barro.cc' target="_blank" rel="noreferrer">Barro Galería</a></p>
                </div>
                <div>
                    <p>Los Angeles, USA</p>
                    <p><a href='http://steveturner.la' target="_blank" rel="noreferrer">Steve Turner Gallery</a></p>
                </div>
            </div>
            <div className='bioInformation'>
                <p>Bio</p>
                <p>
                    Rojas (Buenos Aires), Argentina. 1987.<br />
                    Estudió en la Facultad de Humanidades y Artes de la Universidad Nacional de Rosario. Realizó clínica de obra con Claudia del Río,
                    Ernesto Ballesteros, Rafael Cippolini y Valentina Liernur y participó del Programa de Artistas de la Universidad Torcuato Di Tella.
                    Entre otras muestras colectivas participó de Oh, James, eres tan inteligente…en el Museo de Arte Contemporáneo de Rosario, en la Bienal de Arte Joven
                    de Buenos Aires y el Premio Braque, Universidad Nacional Tres de Febrero y Currículum O organizado por la galería de arte Ruth Benzacar.
                    En 2009 recibió el Premio Adquisición en Dibujo del Salón Nacional de Santa Fe y en 2014 recibió el Primer Premio en el LXVIII  Salón Nacional de Rosario.
                    Ha exhibido  sus pinturas en diferentes ciudades del mundo: Los Ángeles, Bogotá y Ciudad de México. Vive y trabaja en Buenos Aires.
                </p>
            </div>

        </div>
    )
};


// WEBPACK FOOTER //
// ./src/pages/info/Info.jsx